import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Menu, Icon } from 'antd'

import CustomScrollbars from 'util/CustomScrollbars'
import SidebarLogo from './SidebarLogo'

import { ReactComponent as NowIcon } from 'assets/images/now-o-entry.svg'
// import NowIcon from 'assets/images/now-o-entry.svg'

import { THEME_TYPE_LITE } from '../../../redux/Settings/constants'

const MenuItemGroup = Menu.ItemGroup

class SidebarContent extends Component {
    render() {
        const { currentAppId } = this.props
        const { themeType, pathname } = this.props

        const cleanPathname = pathname.substr(1)

        const a = cleanPathname.split('/')
        a.shift()
        const selectedKeys = a.join('/')

        return (
            <div>
                <SidebarLogo />
                <div className="gx-sidebar-content">
                    <CustomScrollbars className="gx-layout-sider-scrollbar">
                        <Menu
                            selectedKeys={[selectedKeys]}
                            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                            mode="inline"
                        >
                            <MenuItemGroup key="stats" className="gx-menu-group">
                                <Menu.Item key="dashboard">
                                    <Link to={`/${currentAppId}/dashboard`}>
                                        <Icon type="dashboard" className="icon" />
                                        <span>Dashboard</span>
                                    </Link>
                                </Menu.Item>
                            </MenuItemGroup>
                            <MenuItemGroup key="application" className="gx-menu-group" title="Application">
                                <Menu.Item key="messages">
                                    <Link to={`/${currentAppId}/messages`}>
                                        <Icon type="message" className="icon" />
                                        <span>Messages</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="users">
                                    <Link to={`/${currentAppId}/users`}>
                                        <Icon type="user" className="icon" />
                                        <span>Users</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="channels">
                                    <Link to={`/${currentAppId}/channels`}>
                                        <Icon type="cluster" className="icon" />
                                        <span>Channels</span>
                                    </Link>
                                </Menu.Item>
                            </MenuItemGroup>
                            <MenuItemGroup key="settings" className="gx-menu-group" title="Settings">
                                <Menu.Item key="settings/installation">
                                    <Link to={`/${currentAppId}/settings/installation`}>
                                        <Icon type="download" className="icon" />
                                        <span>Install</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="settings/webhooks">
                                    <Link to={`/${currentAppId}/settings/webhooks`}>
                                        <Icon type="notification" className="icon" />
                                        <span>Webhooks</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="settings/application">
                                    <Link to={`/${currentAppId}/settings/application`}>
                                        <Icon type="appstore" className="icon" />
                                        <span>Application</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="settings/notifications">
                                    <Link to={`/${currentAppId}/settings/notifications`}>
                                        <Icon type="bell" className="icon" />
                                        <span>Notifications</span>
                                    </Link>
                                </Menu.Item>
                                <Menu.Item key="settings/security">
                                    <Link to={`/${currentAppId}/settings/security`}>
                                        <Icon type="security-scan" className="icon" />
                                        <span>Security</span>
                                    </Link>
                                </Menu.Item>
                            </MenuItemGroup>

                            <MenuItemGroup key="support" className="gx-menu-group" title="Support">
                                <Menu.Item key="documentation">
                                    <a href="https://docs.ekko.chat" target="_blank" rel="noopener noreferrer">
                                        <Icon type="book" className="icon" />
                                        <span>Documentation</span>
                                    </a>
                                </Menu.Item>
                                <Menu.Item key="contact">
                                    <a href={'mailto:support@ekko.chat'}>
                                        <Icon type="contacts" className="icon" />
                                        <span>Contact</span>
                                    </a>
                                </Menu.Item>
                            </MenuItemGroup>
                        </Menu>
                    </CustomScrollbars>
                </div>
            </div>
        )
    }
}

SidebarContent.propTypes = {}
const mapStateToProps = ({ settings, ekko }) => {
    const { themeType, locale, pathname } = settings
    const { currentAppId } = ekko
    return { themeType, locale, pathname, currentAppId }
}
export default connect(mapStateToProps)(SidebarContent)
